import { Component } from "react";
import AppError from "./AppError";
import { JSX } from "react/jsx-runtime";

type State = {
  hasError: boolean;
  error: Error | null;
};

type Props = {
  children?: JSX.Element;
};

export class AppErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error) {
    return { hasError: true, error };
  }

  componentDidCatch() {
    try {
      // Add class to html element to style error page
      window.document.querySelector("body").classList.add("page-app-error");
    } catch {
      /* empty */
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <AppError error={this.state.error} />;
    }

    return this.props.children;
  }
}

export default function appErrorWrapper(WrappedComponent: React.ComponentType) {
  return class AppWrapper extends Component {
    render() {
      const props = this.props || {};

      return (
        <AppErrorBoundary>
          <WrappedComponent {...props} />
        </AppErrorBoundary>
      );
    }
  };
}
